module.exports = __webpack_public_path__ + "img/the-nack-up.1c2b258a.png";